import { SelectTriggerProps } from '@radix-ui/react-select';
import { useMemo, forwardRef } from 'react';
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
} from '@/Domain/components/Shared/Select/Select';
import { MODAL_NAMES } from '@/Domain/store/modal.store';
import { cn } from '@/Domain/utils/cn';

function generateTimeOptions(interval = 15) {
  const times = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += interval) {
      const hour = String(h).padStart(2, '0');
      const minute = String(m).padStart(2, '0');
      times.push(`${hour}:${minute}`);
    }
  }
  return times;
}

export type Props = {
  value: string; // "HH:MM"
  onChange: (time: string) => void;
  variant?: 'bordered' | 'unbordered';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  selectProps?: SelectTriggerProps;
};

export const TimeSelect = forwardRef<HTMLButtonElement, Props>(
  ({ value = '00:00', onChange, variant = 'bordered', size = 'md', selectProps }, ref) => {
    const containerNode = document.getElementById(MODAL_NAMES.HANDOFF_ACTION_SHEET);

    const timeOptions = useMemo(
      () =>
        generateTimeOptions().map((time) => ({
          value: time,
          label: `${time.slice(0, 2)}:${time.slice(3, 5)}`,
        })),
      [],
    );

    return (
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          ref={ref}
          variant={variant}
          size={size}
          className={cn('w-full', selectProps?.className)}
          {...selectProps}
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent containerNode={containerNode}>
          {timeOptions.map(({ value, label }) => (
            <SelectItem value={value} key={value}>
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  },
);

TimeSelect.displayName = 'TimeSelect';
